import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlossaryItemDirective, GlossaryItemHighlightDirective } from './glossary-item.directive';
import { MdDatepickerHighlitDates } from '../../../shared/directives/md-datepicker-highlight-dates.directive';
import { ClickStopPropagation } from '@sportlogiq/shared/directives/stop-propagation.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        GlossaryItemDirective,
        GlossaryItemHighlightDirective,
        MdDatepickerHighlitDates,
        ClickStopPropagation
    ],
    exports: [
        GlossaryItemDirective,
        GlossaryItemHighlightDirective,
        MdDatepickerHighlitDates,
        ClickStopPropagation
    ]
})
export class DirectiveModule { }
